


















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    props: ['notifications'],
})
export default class ConversationPopupPage extends Vue {
    public params: any = {};
    public query: any = {
        isMyText: true,
    };
    public created(): void {
        // tslint:disable-next-line:forin
        for (const par in this.$route.params) {
            this.$set(this.params, par, this.$route.params[par]);
        }
    }
    public stringAvtar(name) {
        if (!name) {
            return name;
        }
        const splited =
            name.indexOf(',') > -1 ? name.split(',') : name.split(' ');
        let av = '';
        splited.forEach((s) => {
            if (s.trim()[0] && av.length < 2) {
                av += s.trim()[0];
            }
        });
        return av;
    }

    public openConversation(item): void {
        this.query.isMyText = false;
        this.query.orphan = !item.customerKey;
        // this.$router.push({ name: 'app.dashboard' });
        this.$router.push({
            name: 'advisor.conversation.messages',
            params: {
                customerKey: item.customerKey || '0',
                storeId: this.params.storeId,
            }, query: this.query,
        });
    }

}
